import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToBottom = this.scrollToBottom.bind(this)
    this.observer = new MutationObserver(() => {
      requestAnimationFrame(this.scrollToBottom)
    })

    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    })

    requestAnimationFrame(this.scrollToBottom)
    window.addEventListener("turbo:render", this.scrollToBottom)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }

    window.removeEventListener("turbo:render", this.scrollToBottom)
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
